import { StatusBar, Style } from '@capacitor/status-bar';

export class StatusBarService {
  // Check if we're on a native platform (not web)
  // Capacitor Core can load on web, but native plugins only work on ios/android
  private static isNativePlatform(): boolean {
    try {
      if (typeof window === 'undefined') return false;
      const Capacitor = (window as any).Capacitor;
      if (!Capacitor) return false;
      
      // getPlatform() returns 'web' on browsers, 'ios' or 'android' on native
      const platform = Capacitor.getPlatform();
      return platform !== 'web';
    } catch {
      return false;
    }
  }

  static async initialize() {
    if (!this.isNativePlatform()) {
      console.log('StatusBarService: Skipping initialize on web platform');
      return; // Skip on web
    }
    
    try {
      // Replicate splash screen behavior
      // Set status bar style to dark content (white text/icons)
      await StatusBar.setStyle({ style: Style.Dark });
      
      // Set background color to match app background
      await StatusBar.setBackgroundColor({ color: '#1a1a1a' });
      
      // Show the status bar
      await StatusBar.show();
      
      // Set overlay to false to match splash screen behavior
      // This ensures content doesn't extend behind the status bar
      await StatusBar.setOverlaysWebView({ overlay: false });
      
      console.log('Status bar initialized with splash screen configuration');
    } catch (error) {
      console.error('Error initializing status bar:', error);
    }
  }

  static async hideForSplash() {
    if (!this.isNativePlatform()) {
      return; // Skip on web
    }
    
    try {
      // Hide status bar during splash screen
      await StatusBar.hide();
      console.log('Status bar hidden for splash');
    } catch (error) {
      console.error('Error hiding status bar for splash:', error);
    }
  }

  static async showForApp() {
    if (!this.isNativePlatform()) {
      console.log('StatusBarService: Skipping showForApp on web platform');
      return; // Skip on web
    }
    
    try {
      // Show status bar and apply app configuration (same as splash)
      await StatusBar.show();
      await StatusBar.setStyle({ style: Style.Dark });
      await StatusBar.setBackgroundColor({ color: '#1a1a1a' });
      await StatusBar.setOverlaysWebView({ overlay: false });
      console.log('Status bar shown for app with splash configuration');
    } catch (error) {
      console.error('Error showing status bar for app:', error);
    }
  }
}
